import { Dialog } from "./Dialog";
import { Button } from "./Button";
import { useTranslation } from "react-i18next";
import { Clock } from "lucide-react";

interface ReservationTimeoutModalProps {
  isOpen: boolean;
  onRestoreBooking: () => void;
  onSearchSameAgain: () => void;
  onGoToStart: () => void;
  showRestoreBooking: boolean;
  showSearchSameAgain: boolean;
  isRestoring?: boolean;
}

const getTimeoutMessageKey = (
  showRestoreBooking: boolean,
  showSearchSameAgain: boolean,
): string => {
  if (showRestoreBooking && !showSearchSameAgain) {
    return "reservation_session.timeout_message_restore_only";
  }
  if (!showRestoreBooking && showSearchSameAgain) {
    return "reservation_session.timeout_message_search_only";
  }
  return "reservation_session.timeout_message";
};

export const ReservationTimeoutModal = ({
  isOpen,
  onRestoreBooking,
  onSearchSameAgain,
  onGoToStart,
  showRestoreBooking,
  showSearchSameAgain,
  isRestoring = false,
}: ReservationTimeoutModalProps) => {
  const { t } = useTranslation();
  const timeoutMessage = t(
    getTimeoutMessageKey(showRestoreBooking, showSearchSameAgain),
  );

  return (
    <Dialog isOpen={isOpen} onClose={() => {}} dismissible={false}>
      <div className="w-full max-w-md p-6">
        <div className="mb-4 flex justify-center">
          <div className="bg-ink/[0.07] rounded-full p-3">
            <Clock className="h-8 w-8" />
          </div>
        </div>

        <h2 className="mb-2 text-center text-xl font-bold text-ink">
          {t("reservation_session.timeout_title")}
        </h2>

        <p className="mb-6 text-center text-sm text-ink-secondary">
          {timeoutMessage}
        </p>

        <div className="flex flex-col gap-3">
          {showRestoreBooking && (
            <Button
              size="medium"
              onClick={onRestoreBooking}
              className="w-full"
              isLoading={isRestoring}
              disabled={isRestoring}
            >
              {t("reservation_session.restore_booking")}
            </Button>
          )}
          {showSearchSameAgain && (
            <Button
              variant="secondary"
              size="medium"
              onClick={onSearchSameAgain}
              className="w-full"
              disabled={isRestoring}
            >
              {t("reservation_session.search_same_again")}
            </Button>
          )}
          <Button
            variant="secondary"
            size="medium"
            onClick={onGoToStart}
            className="w-full"
            disabled={isRestoring}
          >
            {t("reservation_session.go_to_start")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
